import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { UpdateStatus } from "../../app/data/terminal-details/models";
import { initialUpdateStatusState } from "./TerminalStatusState";

const terminalService = TerminalService.getInstance();

export const updateStatusSlice = createSlice({
    name: "updateStatus",
    initialState: initialUpdateStatusState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setUpdateStatus: (state, { payload }) => {
            state.data = payload;
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        },
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.errorMessage = null;
        }
    },
});

export const {
    loading,
    setUpdateStatus,
    error,
    reset
} = updateStatusSlice.actions;

export const updateStatusSelector = (state: IState) => state.updateStatus;

export const updateTerminalStatus = (terminalNumber: string, data: UpdateStatus, callback?: () => void, errorCallback?: (message: string | object) => void): AppThunk => async (dispatch) => {
    if (!terminalNumber) return
    dispatch(loading());
    const response = await terminalService.updateTerminalStatus(terminalNumber, data);
    if (response.ok()) {
        dispatch(setUpdateStatus(response.data));
        callback?.();
    } else {
        if (response.getError()) {
            dispatch(error(response.getError()));
            if(typeof response.getError() === "string" && response.getError() !== "")
                errorCallback?.(response?.getError() || "Error! Please try again later...");
            else
                errorCallback?.("Error! Please try again later...");
        }
    }
};

export const resetUpdateStatus = (): AppThunk => async (dispatch) => {
    dispatch(reset());
};

const updateStatusReducer = updateStatusSlice.reducer;
export default updateStatusReducer;
